<template>
  <div ref="hospedajeRef" class="hospedaje-section">
    <div class="imagen-contenedor animate-item">
      <div class="texto-sobre-imagen animate-item">Te dejamos una Sugerencia de Hospedaje para Reservar.</div>
      <img src="@/assets/hoteles.png" alt="Hospedaje" class="imagen-hospedaje" />
    </div>

    <button @click="mostrarOverlay" class="btn-hospedaje animate-item">
      VER MÁS
    </button>

    <transition name="fade">
      <div v-if="overlayVisible" class="overlay" @click.self="cerrarOverlay">
        <div class="overlay-content">
          <button @click="cerrarOverlay" class="btn-close">×</button>
          <h3 class="overlay-title">Opciones de Hospedaje</h3>

          <div class="hospedaje-tarjeta" v-for="(hotel, index) in hoteles" :key="index">
            <p class="hotel-nombre">{{ hotel.nombre }}</p>
            <p class="hotel-direccion">{{ hotel.direccion }}</p>
            <p class="hotel-telefono"> {{ hotel.telefono }}</p>
            <a :href="hotel.mapa" target="_blank" class="btn-mapa">Reserva Aquí</a>
          </div>

          <button @click="cerrarOverlay" class="btn-cerrar">Cerrar</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'HospedajeSectio--n',
  setup() {
    const hospedajeRef = ref(null)
    const overlayVisible = ref(false)
    const elementosAnimados = ref([])

    const hoteles = [
      {
        nombre: 'Hampton Inn Raleigh/Garner',
        direccion: '110 Drexmere St, Garner, NC 27529',
        telefono: '919 772 65 00',
        mapa: 'https://maps.app.goo.gl/uMJ3GsSWxVPdFtUy5'
      },
     

        {
        nombre: 'Raleigh Marriott City Center',
        direccion: '',
        telefono: '919 833 11 20',
        mapa: 'https://maps.app.goo.gl/Liatgkufeft4dpQb8'
      },

          {
        nombre: 'Quality Inn Raleigh Downtown',
        direccion: '2539 S Saunders St, Raleigh, NC 27603',
        telefono: '+1 919 268 85 08',
        mapa: 'https://maps.app.goo.gl/M7Rkp5D2xwQ25Pve9'
      },
    ]

    const mostrarOverlay = () => {
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value = hospedajeRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(elementosAnimados.value).indexOf(entry.target)
                gsap.fromTo(
                  entry.target,
                  { opacity: 0, y: 40 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: index * 0.2,
                    ease: 'power2.out'
                  }
                )
                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        elementosAnimados.value.forEach((el) => observer.observe(el))
      })
    })

    return {
      hospedajeRef,
      overlayVisible,
      mostrarOverlay,
      cerrarOverlay,
      hoteles
    }
  }
}
</script>

<style scoped>
.hospedaje-section {
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Playfair Display', serif;
  text-align: center;
  padding: 60px 20px;
}

.imagen-contenedor {
  position: relative;
  display: inline-block;
}

.texto-sobre-imagen {
  position: relative;
  top: 10px;
  color: rgb(65, 62, 62);
  font-size: 18px;
  font-family: 'say2', cursive;
  border-radius: 4px;
  margin-bottom: 10px;
  z-index: 10;
  opacity: 0;
}

.imagen-hospedaje {
  width: 100%;
  max-width: 600px;
  margin: 0 auto 20px;
  display: block;
}

.btn-hospedaje {
  background: none;
  border: 1px solid #1a1a1a;
  padding: 8px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-hospedaje:hover {
  background: #1a1a1a;
  color: white;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}

.overlay-content {
  background: #fff;
  color: #1a1a1a;
  border-radius: 12px;
  padding: 20px 15px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: bold;
  color: #1a1a1a;
}

.overlay-title {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  margin-bottom: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hospedaje-tarjeta {
  margin-bottom: 18px;
  text-align: left;
}

.hotel-nombre {
  font-size: 15px;
  font-weight: bold;
}

.hotel-direccion,
.hotel-telefono {
  font-size: 12px;
  color: #444;
}

.btn-mapa {
  display: inline-block;
  margin-top: 6px;
  font-size: 11px;
  padding: 4px 10px;
  border: 1px solid #1a1a1a;
  color: #1a1a1a;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  text-decoration: none;
  transition: 0.3s ease;
}

.btn-mapa:hover {
  background: #1a1a1a;
  color: #fff;
}

.btn-cerrar {
  margin-top: 20px;
  background: none;
  border: 1px solid #1a1a1a;
  padding: 6px 14px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-cerrar:hover {
  background: #1a1a1a;
  color: #fff;
}

.animate-item {
  opacity: 0;
  transform: translateY(40px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
